export const mockData = {
  doula: {
    name: "12 Tribes Doula Services",
    tagline: "Nurturing Black Mothers Through Sacred Birth Journey",
    location: "Central Georgia",
    phone: "(678) 876-1637",
    email: "info@12tribesdoula.com"
  },
  
  about: {
    bio: "As a dedicated birthing doula serving Black women in Central Georgia, I believe every mother deserves to feel empowered, supported, and honored throughout her pregnancy and birth journey. Drawing from ancestral wisdom and holistic healing traditions, I provide compassionate care rooted in natural practices, herbal medicine, and spiritual wellness.",
    mission: "To create a safe, nurturing space where Black mothers can reclaim their birth experiences through holistic support, cultural reverence, and evidence-based natural care.",
    experience: "Over 8 years supporting families through prenatal, birth, and postpartum journeys",
    certifications: ["Certified Birth Doula", "Herbalist", "Holistic Health Practitioner", "Lactation Counselor"]
  },
  
  services: [
    {
      id: 1,
      title: "Prenatal Support",
      description: "Comprehensive care throughout your pregnancy with regular check-ins, birth planning, and preparation for the journey ahead.",
      details: ["Monthly wellness visits", "Birth plan development", "Partner preparation", "Nutritional guidance"],
      accentClass: "accent-purple",
      image: "https://images.unsplash.com/photo-1691211395440-5b23540aee70?auto=format&fit=crop&q=80&w=600"
    },
    {
      id: 2,
      title: "Labor Support",
      description: "Continuous physical, emotional, and spiritual support during labor and delivery, honoring your birth preferences.",
      details: ["Continuous labor support", "Comfort measures", "Advocacy", "Partner coaching"],
      accentClass: "accent-blue",
      image: "https://images.unsplash.com/photo-1710897869539-a48e3d69a8d7?auto=format&fit=crop&q=80&w=600"
    },
    {
      id: 3,
      title: "Postpartum Care",
      description: "Nurturing care for mother and baby during the critical fourth trimester with healing support and guidance.",
      details: ["Home visits", "Newborn care education", "Breastfeeding support", "Healing protocols"],
      accentClass: "accent-orange",
      image: "https://images.pexels.com/photos/6393377/pexels-photo-6393377.jpeg?auto=compress&cs=tinysrgb&w=600"
    },
    {
      id: 4,
      title: "Herbal Consultations",
      description: "Personalized herbal remedies and natural wellness plans using traditional plant medicine for reproductive health.",
      details: ["Custom herbal protocols", "Fertility support", "Pregnancy wellness", "Postpartum healing"],
      accentClass: "accent-pink",
      image: "https://images.unsplash.com/photo-1571934811356-5cc061b6821f?auto=format&fit=crop&q=80&w=600"
    },
    {
      id: 5,
      title: "Tea Blends & Natural Healing",
      description: "Specially crafted organic herbal teas and natural remedies to support you through each stage of motherhood.",
      details: ["Pregnancy teas", "Labor preparation blends", "Postpartum recovery teas"],
      accentClass: "accent-green",
      image: "https://images.pexels.com/photos/105028/pexels-photo-105028.jpeg?auto=compress&cs=tinysrgb&w=600"
    }
  ],
  
  blogPosts: [
    {
      id: 1,
      title: "Choosing a Doula in Central Georgia: What Black Mothers Need to Know",
      slug: "choosing-doula-central-georgia-black-mothers",
      excerpt: "Finding the right doula in Central Georgia is a crucial decision for your birth journey. Learn what to look for and questions to ask when selecting a culturally-centered birth support professional.",
      content: `
# Choosing a Doula in Central Georgia: What Black Mothers Need to Know

If you're a Black mother in Central Georgia seeking holistic birth support, finding the right doula can transform your pregnancy and birth experience. Here's everything you need to know about choosing a doula who will honor your culture, traditions, and birth preferences.

## What is a Doula?

A doula is a trained birth professional who provides continuous physical, emotional, and informational support before, during, and after childbirth. Unlike medical staff, doulas focus exclusively on your comfort, advocacy, and empowerment throughout your birth journey.

## Why Black Mothers in Georgia Need Culturally-Centered Doula Care

Black mothers in the United States, including Georgia, face significantly higher rates of maternal mortality and morbidity. Having a doula who understands your cultural background, respects your experiences, and advocates for your needs can make a profound difference in your birth outcomes.

Research shows that continuous doula support can lead to:
- Shorter labor times
- Reduced need for pain medication
- Lower rates of cesarean births
- More positive birth experiences
- Better postpartum outcomes

## What to Look for in a Central Georgia Doula

### Cultural Competency
Your doula should understand and respect the unique experiences of Black mothers in the healthcare system. Look for someone who centers your cultural traditions and creates a safe space for open communication.

### Holistic Approach
Many Black mothers prefer doulas who incorporate natural healing practices, herbal remedies, and ancestral wisdom alongside evidence-based birth support. Ask potential doulas about their approach to holistic care.

### Experience and Training
While certification isn't everything, inquire about your doula's training, experience supporting Black families, and ongoing education. Personal compatibility matters more than credentials alone.

### Services Offered
Consider what support you need:
- Prenatal visits and birth planning
- Continuous labor support
- Postpartum care and breastfeeding assistance
- Herbal consultations and natural remedies
- Partner preparation and family support

## Questions to Ask Potential Doulas in Macon, Warner Robins, and Surrounding Areas

1. What is your experience supporting Black mothers specifically?
2. How do you incorporate cultural traditions into birth support?
3. What is your philosophy on natural birth and medical interventions?
4. Do you offer herbal remedies or holistic healing options?
5. How do you handle situations where my preferences differ from medical recommendations?
6. What are your fees and payment options?
7. Do you provide backup doula coverage?

## The Importance of Prenatal Connection

Your relationship with your doula begins long before labor. Prenatal visits allow you to build trust, discuss your birth preferences, address fears, and create a comprehensive birth plan. This connection becomes invaluable during labor when you need unwavering support.

## Holistic Birth Support in Central Georgia

In Central Georgia, you have access to doulas who blend traditional birth support with holistic practices including:
- Herbal teas for pregnancy wellness
- Natural pain management techniques
- Ancestral healing wisdom
- Culturally-relevant nutritional guidance
- Spiritual and emotional support

## Making Your Decision

Trust your intuition. The right doula will make you feel heard, respected, and confident in your ability to birth. If something feels off during your initial consultation, keep looking. Your comfort and trust are essential.

## Conclusion

Choosing a doula in Central Georgia is an investment in yourself, your baby, and your birth experience. By selecting someone who honors your culture, understands your needs, and provides holistic support, you're taking a powerful step toward a positive birth journey.

Black mothers deserve care that sees them, celebrates them, and supports them completely. Your birth matters, and you deserve a doula who will stand beside you every step of the way.

---

**Ready to begin your supported birth journey?** Contact 12 Tribes Doula Services at (678) 876-1637 or info@12tribesdoula.com to schedule a free consultation.
      `,
      author: "12 Tribes Doula Services",
      date: "2025-01-15",
      category: "Doula Services",
      image: "https://images.pexels.com/photos/6393375/pexels-photo-6393375.jpeg?auto=compress&cs=tinysrgb&w=800",
      tags: ["doula", "Central Georgia", "Black mothers", "birth support", "holistic care"]
    },
    {
      id: 2,
      title: "The Power of Herbal Medicine During Pregnancy: Ancient Wisdom for Modern Mothers",
      slug: "herbal-medicine-pregnancy-natural-healing",
      excerpt: "Discover how traditional herbal remedies can support your pregnancy journey naturally. Learn about safe, effective herbs used by generations of Black healers and midwives.",
      content: `
# The Power of Herbal Medicine During Pregnancy: Ancient Wisdom for Modern Mothers

For centuries, Black healers and midwives have used herbal medicine to support women through pregnancy, birth, and postpartum recovery. Today, this ancestral wisdom continues to offer safe, effective support for expecting mothers seeking natural wellness options.

## The Legacy of Black Herbalism in Birth Work

Our ancestors understood the healing power of plants long before modern medicine. From Africa to the Americas, Black women have been the keepers of herbal knowledge, passing down remedies through generations. This wisdom represents not just medical knowledge, but cultural resilience and connection to our roots.

## Safe Herbal Support Throughout Pregnancy

### First Trimester: Nourishment and Ease

**Ginger Root**
One of nature's most effective remedies for morning sickness, ginger has been used for centuries to calm nausea and support digestion. Fresh ginger tea can provide relief during those challenging early weeks.

**Red Raspberry Leaf**
Known as the "pregnancy herb," red raspberry leaf tea tones the uterus and prepares your body for labor. Many midwives recommend starting this tea in the second trimester.

### Second Trimester: Building and Strengthening

**Nettle Leaf**
Rich in iron, calcium, and other vital nutrients, nettle tea helps prevent anemia and supports overall health. It's particularly beneficial for Black mothers, who face higher rates of anemia during pregnancy.

**Dandelion Leaf**
This common "weed" is actually a nutritional powerhouse, supporting liver function and providing essential vitamins and minerals for you and your baby.

### Third Trimester: Preparation for Birth

**Red Raspberry Leaf** (continued)
Increase your consumption in the third trimester to tone the uterine muscles and prepare for efficient contractions.

**Dates**
While not technically an herb, dates eaten daily in late pregnancy have been shown to support cervical ripening and reduce labor time.

## Postpartum Healing with Herbs

### Recovery and Nourishment

**Moringa**
This nutrient-dense herb supports milk production and provides essential vitamins for postpartum recovery. It's been used by African mothers for generations.

**Sitz Bath Herbs**
Combining calendula, lavender, and witch hazel creates a healing bath for perineal recovery after birth.

### Emotional Wellness

**Chamomile**
Gentle and calming, chamomile tea supports rest and emotional balance during the postpartum period.

**Oatstraw**
Nourishing to the nervous system, oatstraw helps with stress management and emotional regulation.

## Working with a Holistic Doula

A knowledgeable doula with herbal training can:
- Recommend appropriate herbs for your specific needs
- Create custom tea blends for different pregnancy stages
- Teach you about safe usage and preparation
- Connect you with quality, organic herb sources
- Support you in communicating with your healthcare providers about herbal use

## Important Safety Considerations

While herbal medicine offers many benefits, safety is paramount:

1. **Always consult your healthcare provider** before starting any herbal regimen, especially if you have medical complications
2. **Source quality herbs** from reputable suppliers
3. **Avoid certain herbs** that are contraindicated during pregnancy (your doula can guide you)
4. **Start slowly** and pay attention to how your body responds
5. **Work with a knowledgeable practitioner** rather than self-prescribing

## Reclaiming Our Healing Traditions

Using herbal medicine during pregnancy is more than just natural healthcare—it's a way to connect with our ancestors, honor our bodies' wisdom, and reclaim agency over our birth experiences. In a medical system that hasn't always served Black mothers well, these traditional practices offer autonomy and ancestral connection.

## Creating Your Herbal Support Plan

If you're interested in incorporating herbal medicine into your pregnancy:

1. **Research** trusted herbalists and doulas in Central Georgia
2. **Schedule a consultation** to discuss your health history and goals
3. **Start with basics** like raspberry leaf or nettle tea
4. **Keep a journal** tracking how different herbs affect you
5. **Build your knowledge** through books and workshops about Black herbalism

## Conclusion

Herbal medicine offers pregnant mothers a bridge between ancient wisdom and modern wellness. By incorporating these time-tested remedies into your pregnancy journey, you're not just supporting your physical health—you're connecting with generations of strong Black mothers who came before you.

Your body knows how to grow and birth your baby. Herbs simply support what your body already knows how to do.

---

**Interested in herbal consultations for your pregnancy?** Contact 12 Tribes Doula Services at (678) 876-1637 or info@12tribesdoula.com to learn about personalized herbal support.
      `,
      author: "12 Tribes Doula Services",
      date: "2025-01-10",
      category: "Holistic Health",
      image: "https://images.unsplash.com/photo-1571934811356-5cc061b6821f?auto=format&fit=crop&q=80&w=800",
      tags: ["herbal medicine", "pregnancy", "natural healing", "holistic health", "ancestral wisdom"]
    },
    {
      id: 3,
      title: "Postpartum Care for Black Mothers: Why the Fourth Trimester Matters",
      slug: "postpartum-care-fourth-trimester-black-mothers",
      excerpt: "The postpartum period is crucial for maternal health and bonding. Learn why Black mothers need specialized support during the fourth trimester and how doula care can make all the difference.",
      content: `
# Postpartum Care for Black Mothers: Why the Fourth Trimester Matters

While much attention focuses on pregnancy and birth, the postpartum period—often called the fourth trimester—is equally crucial for maternal health and wellbeing. For Black mothers in Central Georgia, having culturally-centered postpartum support can literally be life-saving.

## Understanding the Fourth Trimester

The fourth trimester refers to the first 12 weeks after birth, a time of tremendous physical, emotional, and lifestyle adjustment. Your body is healing, hormones are shifting dramatically, and you're learning to care for your newborn while recovering from birth.

## Why Black Mothers Need Specialized Postpartum Care

### The Statistics Tell a Story

Black mothers in the United States face:
- 3-4 times higher maternal mortality rates than white mothers
- Higher rates of postpartum complications
- Less access to quality postpartum care
- Greater risk of postpartum depression and anxiety

Many of these complications occur in the postpartum period, not during birth itself. This makes the fourth trimester a critical window for support and intervention.

### Cultural and Systemic Barriers

Black mothers often encounter:
- Medical gaslighting when reporting symptoms
- Lack of culturally competent healthcare providers
- Limited support networks due to geographic or economic factors
- Pressure to "bounce back" quickly without adequate rest

## Essential Components of Postpartum Doula Care

### Physical Recovery Support

**Healing from Birth**
Whether you had a vaginal or cesarean birth, your body needs time and support to heal:
- Perineal care and comfort measures
- Cesarean incision care
- Managing bleeding and understanding warning signs
- Physical recovery exercises when appropriate

**Nutritional Support**
Postpartum nutrition is crucial for healing and, if breastfeeding, milk production. Traditional postpartum foods from African and Black American traditions provide deep nourishment:
- Warming, easily digestible meals
- Iron-rich foods to rebuild blood
- Hydrating herbal teas
- Foods that support milk production

**Rest and Sleep**
Sleep deprivation can complicate recovery and increase postpartum mood disorder risk. A postpartum doula helps ensure you get adequate rest.

### Breastfeeding Support

Many Black mothers want to breastfeed but face barriers including:
- Lack of culturally sensitive lactation support
- Return to work pressures
- Limited family support or experience
- Medical complications

A knowledgeable doula can provide:
- Latch assistance and positioning help
- Troubleshooting common challenges
- Emotional support through difficulties
- Referrals to IBCLCs when needed

### Emotional and Mental Health Support

**Postpartum Mood Disorders**
Black mothers experience postpartum depression at similar or higher rates than other groups but are less likely to receive diagnosis or treatment due to:
- Stigma around mental health in the community
- Providers' failure to screen appropriately
- Lack of access to culturally competent mental health care

A postpartum doula watches for warning signs and connects you with appropriate resources.

**Processing Your Birth Experience**
Regardless of how your birth unfolded, you need space to process the experience, especially if it differed from your hopes or involved trauma.

### Newborn Care Education

Confident, informed parents are better able to care for their babies. Postpartum doulas provide:
- Newborn care basics (diapering, bathing, soothing)
- Understanding baby sleep patterns
- Recognizing hunger cues
- When to call the pediatrician

### Partner and Family Support

Your partner and family members also need guidance:
- How to support your recovery
- Ways to bond with the baby
- Sharing responsibilities
- Communication strategies

## Ancestral Postpartum Practices

Many cultures have beautiful postpartum traditions that honor the mother's recovery period:

**Mother Warming**
Using warm compresses, baths, and clothing to support healing and comfort.

**Belly Binding**
Traditional abdominal binding provides physical support and helps the uterus return to pre-pregnancy size.

**Sitting Month**
The practice of extended rest (often 30-40 days) where the mother is cared for by her community while she bonds with her baby.

**Special Foods**
Warming, nourishing foods prepared specifically for postpartum recovery.

## Warning Signs Never to Ignore

Contact your healthcare provider immediately if you experience:
- Heavy bleeding (soaking more than one pad per hour)
- Fever over 100.4°F
- Severe headaches or vision changes
- Chest pain or difficulty breathing
- Thoughts of harming yourself or your baby
- Severe swelling or leg pain
- Foul-smelling discharge

Black mothers' concerns are too often dismissed. Advocate fiercely for yourself, and bring a support person to medical appointments if possible.

## Creating Your Postpartum Support Plan

Before birth, consider:

1. **Arranging help**: Line up family, friends, or professional support
2. **Preparing meals**: Stock your freezer with nourishing foods
3. **Setting boundaries**: Plan to limit visitors in early weeks
4. **Scheduling checkups**: Book your postpartum medical appointments
5. **Identifying resources**: Know who to call for breastfeeding help, mental health support, etc.

## The Gift of Postpartum Doula Care

Investing in postpartum doula support is investing in your health, your baby's wellbeing, and your family's future. A doula provides:
- Continuity of care from pregnancy through postpartum
- Someone who knows your birth story and goals
- Culturally-centered support
- An advocate who listens and believes you
- Practical help and emotional nurturing

## Conclusion

The fourth trimester is not a "nice to have" support period—it's essential. Black mothers deserve care that honors their experiences, celebrates their strength, and supports their recovery. You grew and birthed a human being. You deserve to be cared for as you care for your newborn.

Your postpartum recovery matters. You matter.

---

**Need postpartum support in Central Georgia?** Contact 12 Tribes Doula Services at (678) 876-1637 or info@12tribesdoula.com for compassionate fourth trimester care.
      `,
      author: "12 Tribes Doula Services",
      date: "2025-01-05",
      category: "Postpartum Care",
      image: "https://images.pexels.com/photos/6393377/pexels-photo-6393377.jpeg?auto=compress&cs=tinysrgb&w=800",
      tags: ["postpartum care", "fourth trimester", "Black mothers", "maternal health", "doula support"]
    }
  ],
  
  testimonials: [
    {
      id: 1,
      name: "Amara J.",
      location: "Macon, GA",
      text: "She made me feel seen, heard, and supported in ways I never experienced before. My birth was beautiful and empowering."
    },
    {
      id: 2,
      name: "Keisha M.",
      location: "Warner Robins, GA",
      text: "The herbal teas and natural remedies were life-changing during my pregnancy. I felt connected to my ancestors through this journey."
    },
    {
      id: 3,
      name: "Nia T.",
      location: "Milledgeville, GA",
      text: "Having her by my side during labor gave me strength I didn't know I had. Every Black mother deserves this level of care."
    }
  ]
};
